import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({
    providedIn: "root",
})
export class NifService {
    private nifSubject: BehaviorSubject<string>;

    constructor() {
        this.nifSubject = new BehaviorSubject<string>("");
    }

    setNifValue(value: string) {
        this.nifSubject.next(value);
    }

    getNifValue(): BehaviorSubject<string> {
        return this.nifSubject;
    }
}
